module.exports = __webpack_public_path__ + "img/ssl-badge-new-e1540329078545-1536x1536.01442a21.png";